import React, { useState } from 'react'
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField as MuiTextField,
  Typography,
} from '@material-ui/core'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { MeasureLabel } from 'src/modules/supply_chain/components/Print/MeasureLabel'
import { Product } from 'src/api/models'

interface MeasurementCardProps {
  product: Product
  unitOfMeasure: string
  measure: (measurement: number) => void
}

export const MeasurementCard = (props: MeasurementCardProps) => {
  const { measure, unitOfMeasure, product } = props
  const [value, setValue] = useState(0)
  const { print, renderPrintComponent } = useAsyncPrint()

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault()
    measure(value)
  }

  return (
    <Card>
      {renderPrintComponent()}
      <CardContent>
        <Typography variant="h1">Measure the quantity (in lbs):</Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Button
                variant="contained"
                disabled={value === 0}
                onClick={() =>
                  print((props) => (
                    <MeasureLabel
                      {...props}
                      product={product}
                      measure={value}
                      unitOfMeasure={unitOfMeasure}
                    />
                  ))
                }
              >
                Print {value} {unitOfMeasure} Label
              </Button>
            </Grid>
            <Grid item xs={12}>
              <MuiTextField
                id="measurement"
                name="measurement"
                type="number"
                variant="standard"
                label={`In ${unitOfMeasure}`}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(parseInt(e.target.value))
                }
                value={value}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" color="primary" type="submit">
                Save
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  )
}
